import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import { Breadcrumb, Button, Drawer, Select } from "antd";
import {
  DoubleRightOutlined,
  DownloadOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import ShimmerLoader from "../../../loading";
import "../../../../src/styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../../Routes";
import LoadingSpinner from "../../../components/Loading";

import dayjs from "dayjs";
import i18next from "i18next";
import { toast } from "react-toastify";
import DateFilter from "../../../components/ui/DateFilter";
import { URLS } from "../../../API/API endpoints";
import axiosInstance from "../../../AxiosInstance";
import ExportCasInOutReportModal from "../../SessionHistory/ExportCasInOutReportModal";
import { GetPaymentMethods } from "../../../API  Functions/CashierSetup";
import moment from "moment";
import { checkPermission } from "../../../Utils/permissionHelper";
import SearchBox from "../../../components/CustomWidgets/SearchBox";
import SalesmanReportTable from "./SalesmanReportTable";
import { getAllSalesman } from "../../../API  Functions/SalesmanApis";

const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
};

const SalesmanReport = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const [reportData, setSalesmanReportData] = useState([]);
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [allMethods, setAllMethods] = useState([]);
  const [allcategory, setAllCategory] = useState([]);
  const [allSubcategory, setAllSubCategory] = useState([]);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [query, setquery] = useState("");

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [allSessions, setAllSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedSaleman, setSelectedSaleman] = useState(null);
  const [allSalesmanData, setAllSalesmanData] = useState([]);

  useEffect(() => {
    // if (user_id) {
    GetMethods();
    // GetCategory();
    GetSessions();
    GetSalesmanData();
    GetSalesmansaleWiseRepoort(
      query,
      selectedSession,
      selectedSaleman,
      startDate,
      endDate,
      currentOffset,
      currentLimit,
    );
    // }
  }, [currentLimit, currentOffset]);

  const GetSalesmanData = async () => {
    try {
      const res1 = await getAllSalesman(company_id);

      if (res1?.result?.status_code === 200) {
        const activeUsers = res1.result?.data;
        console.log("Slesmans===>", activeUsers);

        setAllSalesmanData(activeUsers);
      } else {
        setAllSalesmanData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  };

  const GetSessions = async () => {
    try {
      const response = await axiosInstance.post(URLS.GET_POS_SESSION_LIST, {
        company_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      });

      if (response?.data?.result?.status_code === 200) {
        setAllSessions(response.data.result.data);
      } else {
        setAllSessions([]);
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setAllSessions([]);
    }
  };

  const GetMethods = async () => {
    try {
      const res1 = await GetPaymentMethods({ user_id: user_id });
      if (res1?.result[0].status_code == 200) {
        setAllMethods(res1?.result[0].response);
      } else {
        setAllMethods([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    }
  };

  const GetCategory = async () => {
    try {
      // setloading(true);
      const response = await axiosInstance.post(URLS.GET_PARENT_CATEGORY, {
        store_id: company_id,
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
      });
      if (response?.data?.result?.status_code === 200) {
        setAllCategory(response?.data?.result?.data);
      } else {
        setAllCategory([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const GetSubCategory = async (id) => {
    try {
      // setloading(true);
      const response = await axiosInstance.post(URLS.GET_SUB_CATEGORY, {
        store_id: company_id,
        parent_categ_id: id,
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        search: "",
      });
      if (response?.data?.result?.status_code === 200) {
        setAllSubCategory(response?.data?.result?.data);
      } else {
        setAllSubCategory([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const GetSalesmansaleWiseRepoort = async (
    text,
    session,
    salesman,
    start,
    end,
    offset,
    limit,
  ) => {
    try {
      // setloading(true);
      console.log("search==>", searchByShortCode);
      const response = await axiosInstance.post(URLS.GET_SALESMAN_REPORT, {
        company_id: company_id,
        search: searchByShortCode ? "" : text,
        short_code: searchByShortCode ? text : "",
        offset: offset,
        limit: limit,
        start_date: start,
        end_date: end,
        // category_id: cat, //optional
        // sub_category_id: subCat, //optional
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        session_id: session, // optional
        salesman_ids: salesman ? [salesman] : null, // optional
      });
      if (response?.data?.result?.status_code === 200) {
        setSalesmanReportData(response?.data?.result?.data);
      } else {
        setSalesmanReportData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const onSessionChange = (id) => {
    setSelectedSession(id);
    setSelectedSaleman(null);
    setCurrentLimit(10);
    setCurrentOffset(0);
    setquery("");
    GetSalesmansaleWiseRepoort("", id, null, startDate, endDate, 0, 10);
  };

  const onSalesmanChange = (id) => {
    setSelectedSession(null);
    setSelectedSaleman(id);
    setCurrentLimit(10);
    setCurrentOffset(0);
    setquery("");
    GetSalesmansaleWiseRepoort("", null, id, startDate, endDate, 0, 10);
  };

  const handleExport = async (dates) => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      start_date: dates?.startDate,
      end_date: dates?.endDate,
      company_id: company_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_SALESMAN_WISE_SALE_EXCEL,
      payload,
    );
    console.log("handleExport", response);
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_base64);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const filename = `inventory_sale_summary_${timestamp}.${fileExtension}`;
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss"); // Using period for time
      const filename = `${t(
        "salesman_wise_sale",
      )}_${timestamp}.${fileExtension}`;

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      GetSalesmansaleWiseRepoort(value, null, null, startDate, endDate, 0, 10);
    }, 1000),
    [searchByShortCode, startDate, endDate],
  );

  const handleRefresh = () => {
    GetSalesmansaleWiseRepoort(
      query,
      selectedSession,
      selectedSaleman,
      startDate,
      endDate,
      currentOffset,
      currentLimit,
    );
  };

  return (
    <>
      <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden mt-4">
          <div className=" mt-3">
            <div className=" mb-4 ">
              <div className="flex flex-col md:flex-row md:items-center justify-between ">
                {/* Align items and justify space-between */}
                <div className="flex flex-col md:flex-row md:items-center">
                  {/* SESSION DROPDOWN */}
                  <Select
                    showSearch
                    optionFilterProp="children"
                    className="overflow-hidden md:ms-3"
                    style={{
                      width: 340,
                      minWidth: 200,
                      height: 40,
                    }}
                    placeholder={t("All Sessions")}
                    value={selectedSession || null}
                    onChange={onSessionChange}
                  >
                    <Option value={null}>{t("All Sessions")}</Option>

                    {allSessions.map((session) => (
                      <Option key={session?.id} value={session?.id}>
                        {session?.name}
                      </Option>
                    ))}
                  </Select>

                  <div className="mt-2 md:mt-0 mb-2 md:ms-3">
                    <DateFilter
                      setSelectedRange={setSelectedRange}
                      selectedRange={selectedRange}
                      SubmitFilter={(start, end) => {
                        setloading(true);
                        setStartDate(start);
                        setEndDate(end);
                        setSelectedCategory(null);
                        setSelectedSubcategory(null);
                        setSelectedPaymentMethod("");
                        setCurrentLimit(10);
                        setCurrentOffset(0);
                        setquery("");
                        GetSalesmansaleWiseRepoort(
                          "",
                          selectedSession,
                          selectedSaleman,
                          start,
                          end,
                          0,
                          10,
                        ); // Fetch all products
                      }}
                    />
                  </div>
                </div>
                {/* Refresh Button positioned at the far right */}
                <div className="flex gap-x-3">
                  <button
                    className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                    // onClick={() => setExportModalOpen(true)}
                    // onClick={() => {
                    //     if (checkPermission("/pos/CategoryWiseSale", isGinne)) {
                    //         setExportModalOpen(true);
                    //     }
                    // }}
                    onClick={() => {
                      if (allStores) {
                        setExportModalOpen(true);
                      } else {
                        if (checkPermission("/pos/CategoryWiseSale", isGinne)) {
                          setExportModalOpen(true);
                        }
                      }
                    }}
                  >
                    <DownloadOutlined
                      style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                    />

                    <span>{t("Download in Excel")}</span>
                  </button>
                  <div
                    className="flex justify-center items-center text-gray-500 cursor-pointer text-sm me-8"
                    onClick={handleRefresh} // Trigger refresh on click
                  >
                    <ReloadOutlined />
                    <p className="ms-2">{t("Refresh")}</p>
                  </div>
                </div>
              </div>
              <div className="flex justify-between  md:mx-3 gap-x-3 mt-2 mb-5">
                {/* Clear Filter Button */}
                <div className="flex gap-x-2 w-full md:w-auto">
                  <div className="w-[65%] md:w-[42%]">
                    <SearchBox
                      value={query}
                      // showBarcode={true}
                      searchResult={(values) => {
                        setquery(values);
                        setloading(true);
                        setSelectedSession(null);
                        setSelectedSaleman(null);
                        debouncedSearch(values);
                      }}
                      placeholder={t("Search by Product")}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setSearchByShortCode(!searchByShortCode);
                    }}
                    className={`h-[40px] px-2 rounded-md border text-sm whitespace-nowrap ${
                      searchByShortCode
                        ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                        : "bg-white border-gray-300 text-gray-700"
                    }`}
                  >
                    {t("Search Code")}
                  </button>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    className="overflow-hidden "
                    style={{
                      width: 340,
                      minWidth: 200,
                      height: 40,
                    }}
                    placeholder={t("All Salesmans")}
                    value={selectedSaleman || null}
                    onChange={onSalesmanChange}
                  >
                    <Option value={null}>{t("All Salesmans")}</Option>

                    {allSalesmanData.map((val) => (
                      <Option key={val?.id} value={val?.id}>
                        {`${val?.name} (${val.phone_no})`}
                      </Option>
                    ))}
                  </Select>
                </div>
                <button
                  className="h-10 px-4 text-primaryBlue text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                  onClick={() => {
                    // Reset filters
                    setSelectedSession(null);
                    setSelectedSaleman(null);
                    // Reset date to this month
                    const today = dayjs();
                    const defaultStart = today
                      .startOf("month")
                      .format("YYYY-MM-DD");
                    const defaultEnd = today.format("YYYY-MM-DD");
                    setStartDate(defaultStart);
                    setEndDate(defaultEnd);
                    setSelectedRange("thisMonth");

                    // Reset pagination
                    setCurrentLimit(10);
                    setCurrentOffset(0);
                    setquery("");

                    // Fetch default data
                    GetSalesmansaleWiseRepoort(
                      "",
                      null,
                      null,
                      defaultStart,
                      defaultEnd,
                      0,
                      10,
                    );
                  }}
                >
                  {t("Clear Filter")}
                </button>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <ShimmerLoader />
        ) : (
          <>
            <SalesmanReportTable
              additionalData={reportData}
              pagination={(values) => {
                // setloading(true);
                console.log("values=---------->", values);

                setCurrentLimit(values.limit);
                setCurrentOffset(values.offset);
              }}
            />
          </>
        )}
      </div>

      {exportModalOpen && (
        <ExportCasInOutReportModal
          heading={t("Download Salesman Wise Sale")}
          isOpen={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          onExport={(dates) => handleExport(dates)}
        />
      )}
    </>
  );
};

export default SalesmanReport;
